import {
  DataResourceDetail,
  DataResourceDetailRequirement,
  DetailRequirement,
  EngagementStatusBlock,
  EngagementTaskTrait,
  ResourceDataType,
  TaskDataResponse,
  TaskDataTraitStatus,
  TaskFieldDetails,
} from '@cibo/core'
import { propEq } from 'ramda'

export type TASK_DETAIL_KEY_NAME = 'userDetails' | 'wfDetails' | 'fieldDetails'

export const TASK_DETAIL_KEY: Record<ResourceDataType, TASK_DETAIL_KEY_NAME> = {
  user: 'userDetails',
  workflow: 'wfDetails',
  field: 'fieldDetails',
}

export class TaskDataModel
  implements
    Pick<
      TaskDataResponse,
      'detailRequirements' | 'status' | 'fieldDetails' | 'userDetails' | 'wfDetails'
    >
{
  detailRequirements: DataResourceDetailRequirement[]
  status: EngagementStatusBlock

  fieldDetails?: TaskFieldDetails[]
  userDetails?: DataResourceDetail[]
  wfDetails?: DataResourceDetail[]

  traits?: TaskDataTraitStatus[]

  constructor(data: TaskDataResponse) {
    this.detailRequirements = data.detailRequirements
    this.status = data.status
    this.fieldDetails = data.fieldDetails
    this.userDetails = data.userDetails
    this.wfDetails = data.wfDetails
    this.traits = data.traits
  }

  getDetail({
    traitConfig,
    detailRequirement,
    resourceId,
  }: {
    traitConfig: EngagementTaskTrait
    detailRequirement?: DetailRequirement
    resourceId?: string
  }) {
    const taskDataTypeDetails = this[TASK_DETAIL_KEY[traitConfig.dataType]]

    const resourceDetails =
      traitConfig.dataType === 'field'
        ? (taskDataTypeDetails as TaskFieldDetails[])?.find(propEq('resourceId', resourceId))
            ?.details
        : (taskDataTypeDetails as DataResourceDetail[])

    return resourceDetails?.find(detail => {
      return detail.traitId === traitConfig.traitId && detail.year === detailRequirement?.year
    })
  }

  getDetailValue({
    traitConfig,
    detailRequirement,
    resourceId,
  }: {
    traitConfig: EngagementTaskTrait
    detailRequirement?: DetailRequirement
    resourceId?: string
  }) {
    const detail = this.getDetail({ traitConfig, detailRequirement, resourceId })

    if (!detail) return undefined

    if (!traitConfig.detailValueKey) {
      throw new Error('detailValueKey is not defined')
    }

    return detail[traitConfig.detailValueKey]
  }

  getTraitStatus(traitId: string): TaskDataTraitStatus | undefined {
    return this.traits?.find(propEq('traitId', traitId))
  }
}
